import { FC, ReactNode } from 'react';
import { CaretDown } from 'phosphor-react';
import { motion } from 'framer-motion';
import { CmsProduct, ShopContent } from '../../../types/cms_shared_types';
import { Conditional } from '../../Common/Conditional';
import { TooltipHelper } from '../TooltipHelper';
import { caretTransitionVariants } from '../ShoppingCart/ShoppingProduct';

interface ExtraProductDrawerProps {
  showExtraProductsDrawer: boolean;
  setShowExtraProductsDrawer: (value: boolean) => void;
  productsInExtra: CmsProduct[];
  displayProductsFunc: (products: CmsProduct[]) => ReactNode;
  cmsShopContent: ShopContent;
}

export const ExtraProductDrawer: FC<ExtraProductDrawerProps> = ({
  showExtraProductsDrawer,
  setShowExtraProductsDrawer,
  productsInExtra,
  displayProductsFunc,
  cmsShopContent,
}) => {
  const displayText = () => {
    if (productsInExtra.length === 1) {
      return showExtraProductsDrawer
        ? cmsShopContent.productChoiceStep.extraProductOpened
        : cmsShopContent.productChoiceStep.extraProductClosed;
    } else {
      return showExtraProductsDrawer
        ? cmsShopContent.productChoiceStep.extraProductsOpened.replace('{x}', productsInExtra.length.toString())
        : cmsShopContent.productChoiceStep.extraProductsClosed.replace('{x}', productsInExtra.length.toString());
    }
  };

  return (
    <div className="flex flex-col w-full pb-3 mt-2 mr-auto border-input-border">
      <Conditional condition={showExtraProductsDrawer} trueRender={<>{displayProductsFunc(productsInExtra)}</>} />

      <div
        onClick={() => setShowExtraProductsDrawer(!showExtraProductsDrawer)}
        className="flex flex-row items-center py-1 cursor-pointer"
      >
        <div className="p-1 mr-1 text-sm font-bold text-sami-green">{displayText()}</div>
        <TooltipHelper text={cmsShopContent.productChoiceStep.extraProductsTooltip} />

        <motion.div
          className="ml-auto text-icon"
          variants={caretTransitionVariants}
          animate={showExtraProductsDrawer ? 'open' : 'closed'}
        >
          <CaretDown size={22} />
        </motion.div>
      </div>
    </div>
  );
};
